/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentTagViewModel } from './documentTagViewModel';
import { DocumentTypeViewModel } from './documentTypeViewModel';

export interface DocumentDetailsViewModel {
  id?: string;
  rowId?: number;
  datasetId?: string;
  fileName?: string | null;
  fileType?: string | null;
  documentTypes?: Array<DocumentTypeViewModel> | null;
  documentTags?: Array<DocumentTagViewModel> | null;
  contents?: string | null;
  createdDate?: string;
  createdBy?: string | null;
  readonly uploadedDate?: string;
  readonly uploadedBy?: string | null;
}
